import { Observable } from "rxjs";
import { ObservableFromFetch } from "../ObservableFromFetch"
import { AlcoholTestSampleType } from "./OrderRequestsModel/AlcoholTestSampleType"
import { TestReasonType } from "./OrderRequestsModel/TestReasonType"
import State from "./OrderRequestsModel/State"
import {GetRegulatoryModeDonor} from "../../components/OrderRequests/OrderModels"

export function AlcoholTestSampleTypesObservable(): Observable<AlcoholTestSampleType[]> {
  return ObservableFromFetch<AlcoholTestSampleType[]>("Order/GetAlcoholTestSampleTypes")
}

export function TestReasonsObservable(): Observable<TestReasonType[]> {
  return ObservableFromFetch<TestReasonType[]>("order/getreasons")
}

export function StateObservable(): Observable<State[]> {
  return ObservableFromFetch<State[]>("Order/GetStates")
}

export function RegulatoryModeObservable(regModeId: number): Observable<GetRegulatoryModeDonor[]> {
  return ObservableFromFetch<GetRegulatoryModeDonor[]>(`FFOrderRegulatoryModeDonor/GetRegulatoryModeListByID?regulatoryModeID=${regModeId}`)
}